module.exports = __webpack_public_path__ + "fonts/playfair-display-v22-latin-regular.c44358fd.eot";